import { render, staticRenderFns } from "./OutputTab.vue?vue&type=template&id=b4bf20aa"
import script from "./OutputTab.vue?vue&type=script&lang=js"
export * from "./OutputTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports